Namespace 'Monitoring.Reports.Competition'

class Monitoring.Reports.Competition.CompareResultsView extends Backbone.View
  template: JST['backbone/templates/monitoring/reports/competition/compare_results']
  picture_host: 'graph.facebook.com'

  events:
    'click #export' : 'onExportData'


  initialize:(@options={}) ->
    @social_accounts = @options.selected
    @data = @options.response["data"]
    @metrics = [
      'fans',
      'fans_growth',
      'fans_growth_percentage',
      'posts_on_period',
      'own_posts',
      'user_posts',
      'answered_posts',
      'interactions',
      'comments',
      'shares',
      'reactions',
      'likes',
      'love',
      'haha',
      'wow',
      'sad',
      'angry'
    ]

  render: ->
    @$el.html(@template( { social_accounts: @social_accounts, data: @data, metrics: @metrics } ))
    @_populateTable()

  onExportData: ->
    payload = {
      metrics: @metrics,
      data: @_getExportData()
    }
    $.post("/monitoring/reports/competition/export", payload,  (response) =>
      if response.error
        window.showError('Error during export to excel')
      else
        window.open(response.results.path)
    )

  _getExportData: =>
    result = @data
    _.each @social_accounts, (account) =>
      result[account.fb_id]['name'] = account.name
    result


  _populateTable: =>
    _.each @social_accounts, (account) =>
      account_header = "<th class='social-account-header data-col'>"
      account_header += "<img src='#{@_getPictureLink(account.fb_id)}'>"
      account_header += "<p><span>#{account.name}</span></p></th>"

      @$el.find('#table-header-row').append(account_header)
      @_addMetricsFor(account)

  _addMetricsFor:(account) =>
    _.each @metrics, (metric) =>
      if @_existsMetricFor(metric, account.fb_id)
        field = "<td class='data-col'>#{@_getMetric(metric, account.fb_id)}"
        field += " %" if metric.includes('_percentage')
        field += "</td>"
      else
        field = "<td class='data-col'>No data</td>"
      @$el.find("##{metric}-metric-row").append(field)

  _existsMetricFor: (metric, uid) ->
    @data[uid]? && @data[uid][metric]?

  _getMetric: (metric, uid) ->
    result = @data[uid][metric]
    result = result.toLocaleString('ES-es', {maximumFractionDigits: 2})
    result

  _getPictureLink: (id) ->
    "https://#{@picture_host}/#{id}/picture?width=100&height=100"